import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { UserMinus } from "lucide-react";

export const BajasRecientes = () => {
  const [bajas, setBajas] = useState([]);
  const [motivos, setMotivos] = useState(null);

  useEffect(() => {
    api.get("/bajas").then(({ data }) => setBajas(data)).catch(() => setBajas([]));
    api.get("/bajas/motivos").then(({ data }) => setMotivos(data)).catch(() => {});
  }, []);

  if (bajas.length === 0) return null;

  return (
    <Card className="rounded-2xl p-6 border-border shadow-sm mb-8" data-testid="card-bajas">
      <div className="flex items-center gap-2 mb-5">
        <UserMinus className="h-5 w-5 text-destructive" />
        <h3 className="font-display text-lg font-bold">Bajas recientes</h3>
      </div>
      {motivos?.motivos?.length > 0 && (
        <div className="mb-6 flex flex-wrap gap-2" data-testid="motivos-frecuentes">
          {motivos.motivos.map((m) => (
            <Badge key={m.motivo} variant="outline" className="rounded-full"
              data-testid={`motivo-${m.motivo}`}>
              {m.motivo}: {m.total} ({m.pct}%)
            </Badge>
          ))}
        </div>
      )}
      <div className="divide-y divide-border">
        {bajas.map((b, i) => (
          <div key={`${b.alumno_id}-${i}`} className="py-3.5 flex items-start justify-between gap-4"
            data-testid={`baja-item-${b.alumno_id}`}>
            <div className="min-w-0">
              <p className="font-semibold text-sm">
                {b.alumno} <span className="text-muted-foreground font-normal">{b.matricula}</span>
              </p>
              <p className="text-xs text-muted-foreground mt-0.5">
                {b.sede}{b.plan ? ` · ${b.plan}` : ""} · {(b.fecha || "").slice(0, 10)}
                {b.hasta ? ` · clases hasta ${b.hasta}` : ""}
              </p>
              <p className="text-sm mt-1.5">{b.motivo || "Sin motivo indicado"}</p>
            </div>
            <Badge variant="outline" className="rounded-full shrink-0 gap-1.5 text-destructive border-destructive/40">
              <UserMinus className="h-3 w-3" /> Baja
            </Badge>
          </div>
        ))}
      </div>
    </Card>
  );
};
